module.exports = "../../app/cells/pages/rankings/subscriptions/show/benefits_cell.rb";